import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import IntlMessages from 'helpers/IntlMessages';

const ChatRedirect: React.FC = () => {
  const { username } = useParams<{ username: string }>();
  const discourseUrl = import.meta.env.VITE_DISCOURSE_URL;
  const defaultChatUrl = import.meta.env.VITE_DISCOURSE_CHAT_URL;

  useEffect(() => {
    if (!discourseUrl) {
      console.error('VITE_DISCOURSE_URL is not configured');
      return;
    }

    // Sanitize username to prevent path traversal
    const sanitizedUsername = username ? encodeURIComponent(username) : null;

    const targetUrl = sanitizedUsername
      ? `${discourseUrl}/u/${sanitizedUsername}/summary`
      : defaultChatUrl || `${discourseUrl}/chat/`;
    
    // Redirect immediately
    window.location.href = targetUrl;
  }, [username, discourseUrl, defaultChatUrl]);

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
      <div className="text-center">
        <div className="spinner-border" role="status">
        </div>
        <p className="mt-3"><IntlMessages id="general.loading" /></p>
      </div>
    </div>
  );
};

export default ChatRedirect;
